import * as React from 'react';
import { observer } from 'mobx-react';
import { ButtonCircle } from './button-circle';
import { SVGIcon } from './svg-icon';
import { classes, style } from 'typestyle';
import { shadowSubtle } from '../theme/shadow';
import { transitionQuickEase } from '../theme/transition';
import { colorBrand, colorContrast, colorWhite } from '../theme/color';
import { em, important, px } from 'csx';
import { animationPulse } from '../theme/animation';


export interface ButtonFavouriteProps {
  className?: string;
  isFavourite?: boolean;
  onClick?(event: React.MouseEvent<any>): void;
  isSync?: boolean;
  size?: number;
  label?: string;
  i18n?: {}
}

@observer
export class ButtonFavourite extends React.Component<ButtonFavouriteProps, any> {
  render() {
    const { i18n = ButtonFavourite.i18n, size, isFavourite, isSync, className, onClick, label } = this.props;

    const iconSize = Math.floor(size / 2) - 2;
    const fontSize = px((size / 2) - 1);

    const cz = classes(
      'favourite-button',
      ButtonFavourite.styles.container,
      isFavourite ? ButtonFavourite.styles.added : ButtonFavourite.styles.removed,
      isSync && ButtonFavourite.styles.sync,
      label && ButtonFavourite.styles.withLabel,
      className
    );

    return (
      <ButtonCircle className={cz} size={size} onClick={onClick}>
        <SVGIcon.Favourite size={iconSize} />
        {label && (
          <span style={{ fontSize }}>{label}</span>
        )}
      </ButtonCircle>
    )
  }

  static defaultProps = {
    size: 28,
    isFavourite: false,
    isSync: false
  };

  static i18n = {};

  static styles = {
    container: style({
      boxShadow: shadowSubtle,
      $nest: {
        '& path': {
          transition: `all ${transitionQuickEase}`
        },
        '& svg': {
          marginTop: em(1/16),
          transition: `all ${transitionQuickEase}`
        },
        '& span': {
          transition: `all ${transitionQuickEase}`
        }
      }
    }),
    withLabel: style({
      width: important('auto'),
      padding: '0 1em 0 0.6em',
      $nest: {
        '& span': {
          margin: '0 0 0 0.5em',
          lineHeight: '1em'
        },
        '& svg': {
          margin: '-1px 0 0 0',
        }
      }
    }),
    added: style({
      backgroundColor: important(colorContrast.toString()),
      $nest: {
        '& path': {
          stroke: colorWhite.toString(),
          fill: colorWhite.toString()
        },
        '&:hover': {
          backgroundColor: important(colorContrast.darken(0.15).toString())
        },
        '& span': {
          color: colorWhite.toString()
        }
      }
    }),
    removed: style({
      backgroundColor: important(colorWhite.toString()),
      $nest: {
        '& path': {
          stroke: colorBrand.toString(),
          fill: colorBrand.toString()
        },
        '&:hover': {
          backgroundColor: important(colorBrand.toString())
        },
        '&:hover path': {
          stroke: colorWhite.toString(),
          fill: colorWhite.toString()
        },
        '& span': {
          color: colorBrand.toString()
        },
        '&:hover span': {
          color: colorWhite.toString()
        }
      },
    }),
    sync: style({
      $nest: {
        '& path': {
          ...animationPulse
        }
      }
    })
  };
}